/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Subject_Option_CollaborationInputs */

const en_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collaboration`)
};

const ar_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعاون`)
};

const bn_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সহযোগিতা`)
};

const de_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenarbeit`)
};

const es_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colaboración`)
};

const fr_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collaboration`)
};

const pt_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colaboração`)
};

const zh_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合作`)
};

const tr_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İş birliği`)
};

const ru_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сотрудничество`)
};

const pl_form_subject_option_collaboration = /** @type {(inputs: Form_Subject_Option_CollaborationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Współpraca`)
};

/**
* | output |
* | --- |
* | "Collaboration" |
*
* @param {Form_Subject_Option_CollaborationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_subject_option_collaboration = /** @type {((inputs?: Form_Subject_Option_CollaborationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Subject_Option_CollaborationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_subject_option_collaboration(inputs)
	if (locale === "bn") return bn_form_subject_option_collaboration(inputs)
	if (locale === "de") return de_form_subject_option_collaboration(inputs)
	if (locale === "es") return es_form_subject_option_collaboration(inputs)
	if (locale === "fr") return fr_form_subject_option_collaboration(inputs)
	if (locale === "pt") return pt_form_subject_option_collaboration(inputs)
	if (locale === "zh") return zh_form_subject_option_collaboration(inputs)
	if (locale === "tr") return tr_form_subject_option_collaboration(inputs)
	if (locale === "ru") return ru_form_subject_option_collaboration(inputs)
	if (locale === "pl") return pl_form_subject_option_collaboration(inputs)
	return en_form_subject_option_collaboration(inputs)
});